<template>
	<el-dialog
		append-to-body
		top="10vh"
		:width="dialogWidth"
		:title="dialogTitle"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		@close="close"
	>
		<div style="margin-top:-20px;"></div>
		<template v-if="printBefore">
			<div>
				<div v-for="list in packageInvoiceList" :key="list.packageSn" class="invoice_list">
					<div class="invoice_item">
						<span>{{$t('components.printDialogPackageNo')}}</span>
						{{ list.packageSn }}
					</div>
					<div class="invoice_item">
						<span>{{$t('components.printDialogPrintCopies')}}</span>
						<el-input-number v-model="numberCount" size="small" :min="0" :max="10"></el-input-number>
					</div>
				</div>
			</div>
      <div class="invoice_item" style="margin-bottom: 20px">
        <span><i>*</i>{{$t('components.printDialogPrintContent')}}</span>
        <el-radio-group v-model="printType" >
          <el-radio  label="1">{{$t('components.printDialogPackageDetail')}}</el-radio>
          <el-radio  label="2">{{$t('components.printDialogPackageOuter')}}</el-radio>
        </el-radio-group>
      </div>
			<div class="invoice_item">
				<span><i>*</i>{{$t('components.printDialogPrinter')}}</span>
				<el-select v-model="printerName" size="small" :placeholder="$t('components.printDialogSelectPrinter')">
					<el-option :value="item.deviceName" :label="item.deviceName" v-for="item in pluginList"
							   :key="item.deviceName"></el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('components.cancel')}}</el-button>
                <el-button type="primary" :loading="loading" :disabled="loading" @click="beforeSurePrint">{{$t('components.printDialogConfirmPrint')}}</el-button>
            </span>
		</template>

		<template v-else>
      <div v-if="this.printType=='1'">
        <div v-if="packageInvoiceList.length > 1" class="print_preview">
                <span
                  v-for="(item, index) in packageInvoiceList"
                  :key="index"
                  :style="{background: item.packageSn === packagePriveSn ? '#067cf2' : '#aaa'}"
                  @click="packagePriveSn = item.packageSn">
                    {{ item.packageSn }}
                </span>
        </div>
        <div v-for="(item, index) in packageInvoiceList" :key="index" style="overflow:hidden;">
          <webview
            style="width:100%;float:left;"
            :style="packagePriveSn === item.packageSn && item.src ? 'height:500px;' : 'height:0;'"
            :src="item.src"></webview>
        </div>
      </div>

      <div v-if="this.printType=='2'">
        <div v-if="packageOutInvoiceList.length > 1" class="print_preview">
                <span
                  v-for="(item, index) in packageOutInvoiceList"
                  :key="index"
                  :style="{background: item.packageSn === packagePriveSn ? '#067cf2' : '#aaa'}"
                  @click="packagePriveSn = item.packageSn">
                    {{ item.packageSn }}
                </span>
        </div>
        <div v-for="(item, index) in packageOutInvoiceList" :key="index" style="overflow:hidden;">
          <webview
            style="width:100%;float:left;"
            :style="packagePriveSn === item.packageSn && item.src ? 'height:500px;' : 'height:0;'"
            :src="item.src"></webview>
        </div>
      </div>

		</template>
	</el-dialog>
</template>

<script>
import request from "@/libs/http";
import {ipc} from "@/utils/ipcRenderer";
import {ipcApiRoute} from "@/api/main";

export default {
	props: {
		modalParams: {//勾选单据列表
			type: Array,
			default: () => []
		},
		printKey: {//打印单id
			type: String,
			default: () => 'id'
		},
		defaultCopies: {//默认打印份数
			type: String,
			default: () => '1'
		},
    documentType:{//区分打印单据来源TC||DB
      type: String,
      default: () => 'DPTC'
    }
	},
	data() {
		return {
			loading: false,
			dialogVisible: true,
			printBefore: true,
			dialogTitle: '',
      packagePriveSn:'',
			invoiceList: [],
      packageInvoiceList:[],
      packageOutInvoiceList:[],
			dialogWidth: '940px',
			printerName: '',
			pluginList: [],
      packageTemplateCode:'',
      printerNumber:'',
      printType:'1',
      packageOutTemplateCode:'',
      packageOutTemplateCount:'',
      numberCount:1
		}
	},
	created() {
		this.dialogTitle = this.$t('components.printDialogPrintSetting');
		this.printerName = this.$cache.local.get('printerModel');
    if (this.documentType=='DPDB') {
      this.packageTemplateCode = this.$cache.local.get('deptAllotPackageCode');
      this.printerNumber =this.$cache.local.get('deptAllotPackageCount')
      this.packageOutTemplateCode = this.$cache.local.get('deptAllotPackageWDCode');
      this.packageOutTemplateCount=this.$cache.local.get('deptAllotPackageWDCount')
    }else {
      this.packageTemplateCode = this.$cache.local.get('packageCode');
      this.printerNumber =this.$cache.local.get('packageCount')
      // 外箱模版缓存
      this.packageOutTemplateCode = this.$cache.local.get('deptReturnPackageWDCode');
      this.packageOutTemplateCount=this.$cache.local.get('deptReturnPackageWDCount')
    }
		ipc.invoke(ipcApiRoute.getPrinters, {}).then(list => {
			this.pluginList = list
		})
    this.packageInvoiceList=this.modalParams
    this.packageOutInvoiceList=this.modalParams
    this.packageInvoiceList[0].number=this.printerNumber
    this.packageOutInvoiceList[0].number=this.packageOutTemplateCount
    this.packagePriveSn=this.packageInvoiceList[0]?.packageSn;
	},
	methods: {
		close() {
			this.dialogVisible = false
			this.$emit('close')
		},
    beforeSurePrint() {
      if (!this.printerName) {
        return this.$message({type: 'error', message: this.$t('components.printDialogSelectPrinter'), duration: 2000, showClose: true});
      }
      this.packageInvoiceList[0].number=this.numberCount
      this.packageOutInvoiceList[0].number=this.numberCount
      if (this.printType=='1') {
        this.packageSurePrint()
      }else {
        this.packageOutSurePrint()
      }
    },
    packageSurePrint() {
      this.loading = true;
      let rootUrl = `${request.printPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageTemplateCode}&`
      let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageTemplateCode}&`
      this.packageInvoiceList.forEach(item => {
        let params = {
          id: item['packageId']
        }
        item.src = rootUrl + `printCount=0&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`
        const eggSrc = eggRootUrl + `printCount=${item.number}&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`;
        ipc.invoke(ipcApiRoute.print, {contentUrl: eggSrc, sn: item['invoicesNo']}).then(r => {})
      })
      this.printBefore = false;
      this.loading = false;
      this.dialogWidth = '400px';
      this.dialogTitle = this.$t('components.printDialogPrinting');
    },
    packageOutSurePrint() {
      this.loading = true;
      let rootUrl = `${request.printPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageOutTemplateCode}&`
      let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${this.printerName}&templateCode=${this.packageOutTemplateCode}&`
      this.packageOutInvoiceList.forEach(item => {
        let params = {
          id: item['packageId']
        }
        item.src = rootUrl + `printCount=0&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`
        const eggSrc = eggRootUrl + `printCount=${item.number}&data=${encodeURI(JSON.stringify(params))}&sn=${item['invoicesNo']}`;
        ipc.invoke(ipcApiRoute.print, {contentUrl: eggSrc, sn: item['invoicesNo']}).then(r => {})
      })
      this.printBefore = false;
      this.loading = false;
      this.dialogWidth = '400px';
      this.dialogTitle = this.$t('components.printDialogPrinting');
    }
	}
}
</script>

<style lang="scss" scoped>
.invoice_list {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.invoice_item {
	display: flex;
	align-items: center;
	flex: 1;

	span {
		width: 200px;

		i {
			color: red;
			margin-right: 4px;
		}
	}
}

.print_preview {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	text-align: center;
	color: #fff;
	margin-bottom: 10px;

	span {
		height: 20px;
		background: #aaa;
		border-radius: 4px;
		margin-right: 10px;
		cursor: pointer;
		padding: 0 8px;
		margin-bottom: 5px;
	}
}
</style>
